import {
  AssetPermission,
  OrganizationPermission,
  Role,
} from '@gm-commercial/profile-model';

import { RouteName } from '~/common/models/route.model';
import { lazyWithReload } from '~/common/utils/lazyWithReload';

const CSPlatformDashboardView = lazyWithReload(
  () =>
    import(
      '~/routes/organizations/home/dashboard/csPlatform/CSPlatformDashboardView'
    )
);

const ORGANIZATIONS_HOME_ROUTE = {
  name: RouteName.ORGANIZATIONS_HOME,
  path: '/organizations/:organizationsId/home',
  authorizedPerms: [AssetPermission.READ, OrganizationPermission.READ],
  excludedRoles: [Role.OPERATOR],
  element: CSPlatformDashboardView,
};

export default ORGANIZATIONS_HOME_ROUTE;
